import { useState } from 'react';
import StatCard from '../../components/common/StatCard';
import Button from '../../components/common/Button';
import Icon from '../../components/common/Icon';
import './ActivityLog.css';

const MOCK_EVENTS = [
  { id: 1, type: 'auth', icon: 'lock', title: 'User login successful', user: 'john@l100.ai', tenant: 'L100.ai', time: '12:45:23', ip: '192.168.1.100' },
  { id: 2, type: 'admin', icon: 'settings', title: 'Tenant settings updated', user: 'admin@cachee.io', tenant: 'Cachee', time: '12:44:15', ip: '10.0.0.50' },
  { id: 3, type: 'security', icon: 'shield', title: 'Suspicious login blocked', user: 'unknown', tenant: 'SuperSearch.ai', time: '12:43:02', ip: '45.67.89.10' },
  { id: 4, type: 'api', icon: 'zap', title: 'API key generated', user: 'dev@mirror1.ai', tenant: 'Mirror1.ai', time: '12:41:30', ip: '172.16.0.1' },
  { id: 5, type: 'billing', icon: 'dollar-sign', title: 'Subscription upgraded', user: 'billing@babykong.ai', tenant: 'BabyKong.ai', time: '12:40:00', ip: '192.168.5.25' },
  { id: 6, type: 'user', icon: 'user', title: 'New user invited', user: 'hr@l100.ai', tenant: 'L100.ai', time: '12:38:45', ip: '192.168.1.101' },
];

const ActivityLog = () => {
  const [filterTenant, setFilterTenant] = useState('');
  const [filterType, setFilterType] = useState('');

  const stats = [
    { label: 'Events Today', value: '3,847', change: '12%', changeType: 'positive' },
    { label: 'Auth Events', value: '2,156', change: '56% of total', changeType: 'positive' },
    { label: 'Admin Actions', value: '234', change: '8 flagged', changeType: 'warning' },
    { label: 'API Calls', value: '1,457', change: 'Per minute avg', changeType: 'positive' },
  ];

  const getTypeClass = (type) => {
    const classes = {
      auth: 'event-auth',
      admin: 'event-admin',
      security: 'event-security',
      api: 'event-api',
      billing: 'event-billing',
      user: 'event-user'
    };
    return classes[type] || '';
  };

  const filteredEvents = MOCK_EVENTS.filter(event => {
    if (filterTenant && event.tenant !== filterTenant) return false;
    if (filterType && event.type !== filterType) return false;
    return true;
  });

  return (
    <div className="activity-page">
      <div className="page-header">
        <div>
          <h1 className="page-title">Activity & Audit Log</h1>
          <p className="page-subtitle">Monitor all system events and user actions</p>
        </div>
        <div className="page-actions">
          <Button variant="secondary" icon="arrow-right">Export</Button>
          <Button variant="secondary" icon="info">Alerts</Button>
        </div>
      </div>

      <div className="stats-row">
        {stats.map((stat, index) => (
          <StatCard key={index} {...stat} />
        ))}
      </div>

      {/* Filters */}
      <div className="filters-bar">
        <select
          className="filter-select"
          value={filterTenant}
          onChange={(e) => setFilterTenant(e.target.value)}
        >
          <option value="">All Tenants</option>
          <option value="Cachee">Cachee</option>
          <option value="L100.ai">L100.ai</option>
          <option value="SuperSearch.ai">SuperSearch.ai</option>
          <option value="Mirror1.ai">Mirror1.ai</option>
          <option value="BabyKong.ai">BabyKong.ai</option>
        </select>

        <select
          className="filter-select"
          value={filterType}
          onChange={(e) => setFilterType(e.target.value)}
        >
          <option value="">All Event Types</option>
          <option value="auth">Authentication</option>
          <option value="admin">Admin Actions</option>
          <option value="api">API Calls</option>
          <option value="security">Security Events</option>
          <option value="billing">Billing</option>
          <option value="user">User Management</option>
        </select>

        <div className="search-box">
          <Icon name="search" size="sm" />
          <input type="text" placeholder="Search events..." />
        </div>
      </div>

      {/* Events Timeline */}
      <section className="section">
        <div className="section-header">
          <h3 className="section-title">Event Timeline</h3>
          <Button variant="ghost" size="sm" icon="refresh">Refresh</Button>
        </div>

        <div className="events-timeline">
          {filteredEvents.map((event) => (
            <div key={event.id} className={`event-item ${getTypeClass(event.type)}`}>
              <div className="event-icon">
                <Icon name={event.icon} size="sm" />
              </div>
              <div className="event-content">
                <div className="event-title">{event.title}</div>
                <div className="event-meta">
                  <span>{event.user}</span>
                  <span className="dot">•</span>
                  <span>{event.tenant}</span>
                  <span className="dot">•</span>
                  <span>{event.ip}</span>
                </div>
              </div>
              <div className="event-time">{event.time}</div>
              <Button variant="ghost" size="xs" icon="eye" iconOnly aria-label="View details" />
            </div>
          ))}
        </div>

        <div className="load-more">
          <Button variant="secondary">Load More Events</Button>
        </div>
      </section>
    </div>
  );
};

export default ActivityLog;
